module.exports = __webpack_public_path__ + "static/img/face-cry.27261b3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/face-cry.gif
// module id = WTXi
// module chunks = 0